/**
 * @generated SignedSource<<c78cb81b9952cfebd25c167f9764502e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LazyImageWrapper_item$data = {
  readonly photos: ReadonlyArray<{
    readonly placeholder: string | null;
  } | null> | null;
  readonly " $fragmentType": "LazyImageWrapper_item";
};
export type LazyImageWrapper_item$key = {
  readonly " $data"?: LazyImageWrapper_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"LazyImageWrapper_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LazyImageWrapper_item",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "limit",
          "value": 1
        }
      ],
      "concreteType": "ItemPhoto",
      "kind": "LinkedField",
      "name": "photos",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "placeholder",
          "storageKey": null
        }
      ],
      "storageKey": "photos(limit:1)"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "66b63b781be0b9150b305761f2aac314";

export default node;
